import { ThemeOptionsState, Venue } from '@/types/SharedComponent';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: ThemeOptionsState = {
  sidebarCompact: false,
  userVenues: [],
  selectedVenue: null,
  isLoadingVenues: false,
};

export const themeOptionsSlice = createSlice({
  name: 'themeOptions',
  initialState,
  reducers: {
    setSidebarCompact: (state, action: PayloadAction<boolean>) => {
      state.sidebarCompact = action.payload;
    },
    toggleSidebarAction: state => {
      state.sidebarCompact = !state.sidebarCompact;
    },
    setUserVenuesAction: (state, action: PayloadAction<Venue[]>) => {
      state.userVenues = action.payload;
    },
    addUserVenueAction: (state, action: PayloadAction<Venue>) => {
      state.userVenues?.push(action.payload);
    },
    updateUserVenueAction: (state, action: PayloadAction<Venue>) => {
      const index = state.userVenues?.findIndex(v => v.id === action.payload.id) ?? -1;
      if (index !== -1 && state.userVenues) {
        state.userVenues[index] = { ...action.payload, compliance: state.userVenues[index].compliance };
      }
      if (state.selectedVenue?.id === action.payload.id) {
        state.selectedVenue = { ...action.payload };
      }
    },

    toggleUserVenuesAction: (state, action: PayloadAction<Venue>) => {
      const index = state.userVenues?.findIndex(venue => Number(venue.id) === action.payload.id) ?? -1;
      if (index === -1) {
        state.userVenues?.push(action.payload);
      } else {
        state.userVenues?.splice(index, 1);
      }
    },
    setSelectedVenue: (state, action: PayloadAction<Venue>) => {
      state.selectedVenue = action.payload;
    },
    setIsLoadingVenues: (state, action: PayloadAction<boolean>) => {
      state.isLoadingVenues = action.payload;
    },
  },
});

export const {
  toggleSidebarAction,
  setSidebarCompact,
  setUserVenuesAction,
  setSelectedVenue,
  toggleUserVenuesAction,
  updateUserVenueAction,
  addUserVenueAction,
  setIsLoadingVenues,
} = themeOptionsSlice.actions;

export default themeOptionsSlice.reducer;
